export default function () {
  if (this.$route.name === 'EditSpecialization') {
    this.loadSpecialization()
  }
}
